/// <reference path="../../../teva/selectbox/selectbox.ts" />
/// <reference path="../../common/common/common.ts" />

namespace OfficeGuy.CRM {
    export class CategoryPicker {
        static InitCategoriesPickers(): void {
            Teva.SelectBox.Enable($("input.categorypicker"), {
                QueryMethod: function (Query, QueryByID, PageIndex, Callback) {
                    Common.AjaxRequest({
                        Method: 'GET', 
                        URL: "/schema/categorypicker/",
                        SuccessMethod: function (Response) {
                            var data = {
                                results: [],
                                more: false
                            };
                            for (var i = 0; i < Response.length; i++)
                                data.results.push({ id: Response[i], text: Response[i] });
                            data.results = Teva.SelectBox.FilterResults(data.results, Query, QueryByID);
                            Callback(data, Query);
                        },
                        ShowLoading: false
                    });
                },
                AllowManualValues: true,
                SelectFirstOnClose: true
            });
        }
    }
}